import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Text } from '@alfa-bank/site-text-v2';
import { Spinner } from '@alfa-bank/site-loader/spinner';

import { SuccessWithRedirect as Component } from './success-with-redirect-layout';
import type { TSuccessWithRedirect, IDepsDesktop } from './models';
import styles from './styles/styles.css';

// eslint-disable-next-line styler/check-styler
export const SuccessWithRedirectLayoutDesktop = createWidget<IDepsDesktop, TSuccessWithRedirect>({
    Spinner,
    Text,
    styles,
    isMobile: false,
})(Component);
